import React from 'react';

import { SVGIcon } from '../../UIKit/index';

export default function DCGrayStage(props) {
    return (
        <SVGIcon {...props} viewBox="0 0 503.295 409.32">
            <defs>
                <linearGradient
                    id="linear-gradient"
                    y1="0.5"
                    x2="1"
                    y2="0.5"
                    gradientUnits="objectBoundingBox"
                >
                    <stop offset="0" stopColor="#dae3fe" />
                    <stop offset="1" stopColor="#e9effd" />
                </linearGradient>
                <linearGradient
                    id="linear-gradient-2"
                    x1="0.418"
                    y1="0.966"
                    x2="0.864"
                    y2="-1.577"
                    gradientUnits="objectBoundingBox"
                >
                    <stop offset="0" stopColor="#fe7062" />
                    <stop offset="1" stopColor="#ff928e" />
                </linearGradient>
                <linearGradient id="linear-gradient-3" x1="0" y1="0.5" x2="1" y2="0.5" />
            </defs>
            <g id="Deal_Stages_Over_Time" transform="translate(-4.935 -52.87)">
                <circle
                    id="Ellipse_9"
                    cx="187"
                    cy="187"
                    r="187"
                    transform="translate(132.73 54.37)"
                    fill="#fff"
                    stroke="#707171"
                    strokeMiterlimit="10"
                    strokeWidth="3"
                />
                <path
                    id="Path_120"
                    d="M299.26,116.82c26.95,24,105.43-15.89,110.62,33.76,6.06,58.13-72.57,85-41.46,122.64S376.25,360,271.12,372-9.23,353.39,24.69,292.85s6.46-60.09,1.47-84.41,9-80.72,95.87-45.71S231,56.09,299.26,116.82Z"
                    fill="#f4f5f6"
                />
                <path
                    id="Path_121"
                    d="M59,126.8C78.19,144,185.74,248.61,105.69,367.16c0,0-88.53-50.65-50.27-239.18A2.17,2.17,0,0,1,59,126.8Z"
                    fill="#f4f5f6"
                />
                <path
                    id="Path_122"
                    d="M64.17,152.19c3.07,8.09,5.93,16.25,8.72,24.44s5.44,16.41,8,24.68,5,16.56,7.3,24.9,4.51,16.7,6.54,25.11q1.5,6.3,3,12.64c1,4.22,1.85,8.45,2.67,12.7s1.62,8.5,2.4,12.76,1.45,8.53,2,12.82l.47,3.22c.16,1.07.27,2.14.41,3.22.26,2.15.55,4.29.79,6.45l.65,6.46c.12,1.08.19,2.16.27,3.24l.24,3.24a237.538,237.538,0,0,1,.48,26,.82.82,0,0,1-.86.78.81.81,0,0,1-.78-.85h0a236.839,236.839,0,0,0-.36-25.83l-.23-3.22c-.07-1.08-.14-2.15-.25-3.23l-.62-6.44c-.23-2.14-.51-4.28-.76-6.42-.13-1.07-.24-2.15-.39-3.21l-.46-3.21c-.57-4.27-1.29-8.53-2-12.79s-1.48-8.51-2.34-12.74-1.72-8.46-2.6-12.69-1.87-8.43-2.89-12.63q-3-12.6-6.41-25.1T80,201.58q-3.76-12.39-7.88-24.69c-2.74-8.19-5.57-16.37-8.59-24.45h0a.35.35,0,0,1,.2-.45.36.36,0,0,1,.44.2Z"
                    fill="#e3e2e3"
                />
                <path
                    id="Path_123"
                    d="M472.51,281.46a1.42,1.42,0,0,0-2.26-1.15c-7.56,7.45-28.24,26.35-48.62,31.87-33.19,9-64.66,34.33-57.92,58.47C363.71,370.65,450.76,397.78,472.51,281.46Z"
                    fill="#f4f5f6"
                />
                <path
                    id="Path_124"
                    d="M464,293.2c-.18.3-.36.52-.54.77l-.54.72-1.1,1.42c-.74.94-1.5,1.87-2.26,2.8-1.53,1.85-3.09,3.67-4.67,5.48-3.17,3.6-6.44,7.1-9.79,10.54a262.2,262.2,0,0,1-21.22,19.45c-3.71,3.05-7.56,5.93-11.46,8.73s-7.95,5.4-12.07,7.87-8.39,4.69-12.73,6.76c-2.2,1-4.38,2-6.63,2.82s-4.5,1.66-6.77,2.45a.2.2,0,0,1-.26-.13.21.21,0,0,1,.12-.26h0c4.48-1.67,8.88-3.55,13.16-5.65s8.46-4.44,12.53-6.93,8.06-5.13,11.94-7.92,7.65-5.71,11.37-8.7,7.33-6.14,10.88-9.34l2.64-2.42,2.61-2.47c1.72-1.65,3.45-3.3,5.14-5,3.4-3.37,6.7-6.82,9.94-10.35,1.61-1.76,3.21-3.54,4.78-5.34l2.33-2.73,1.14-1.38.56-.7c.18-.23.38-.48.52-.68h0a.22.22,0,0,1,.29-.05.21.21,0,0,1,.09.24Z"
                    fill="url(#linear-gradient)"
                />
                <path
                    id="Path_125"
                    d="M164.85,134.56c12.64,21.6,81.07,150.29-28.16,236.19,0,0-66.86-73.12,24.48-236.16a2.12,2.12,0,0,1,3.68-.03Z"
                    fill="#f4f5f6"
                />
                <path
                    id="Path_126"
                    d="M162.07,159.45a117.757,117.757,0,0,1,4.66,12c.62,2,1.3,4.08,1.84,6.16.29,1,.58,2.06.86,3.09l.77,3.12a220.673,220.673,0,0,1,4.53,25.27q1.54,12.75,1.83,25.61a247.228,247.228,0,0,1-.75,25.68,215.521,215.521,0,0,1-10,50.32,159.74,159.74,0,0,1-23.72,45.49.824.824,0,0,1-1.31-1h0a158.12,158.12,0,0,0,23.69-44.94,213.851,213.851,0,0,0,10.16-50,242.086,242.086,0,0,0,.86-25.55q-.23-12.79-1.7-25.53A217.181,217.181,0,0,0,169.4,184l-.75-3.11c-.27-1-.56-2-.83-3.08-.53-2.07-1.2-4.09-1.81-6.13a117.818,117.818,0,0,0-4.58-11.93h0a.35.35,0,0,1,.18-.46.34.34,0,0,1,.46.16Z"
                    fill="#e3e2e3"
                />
                <path
                    id="Path_127"
                    d="M440.31,174.64a1.63,1.63,0,0,0-3.15-.2c-4.9,15.63-19,56.2-39.48,77.34C364.33,286.2,341.13,343,360.92,373.4,360.92,373.4,473.79,356.1,440.31,174.64Z"
                    fill="#f4f5f6"
                />
                <path
                    id="Path_128"
                    d="M436.45,197c-.06.49-.15.92-.22,1.37l-.25,1.34-.53,2.66c-.37,1.77-.76,3.54-1.15,5.31q-1.19,5.29-2.5,10.56c-1.75,7-3.68,14-5.72,21s-4.25,13.84-6.61,20.69-4.83,13.65-7.52,20.38a351.853,351.853,0,0,1-18.36,39.37c-.43.8-.88,1.59-1.34,2.37l-1.35,2.36-1.36,2.35c-.46.78-1,1.55-1.42,2.32-1,1.54-1.88,3.1-2.86,4.62l-3,4.54a192.059,192.059,0,0,1-13.2,17.26.22.22,0,0,1-.29,0,.21.21,0,0,1,0-.29h0a207.859,207.859,0,0,0,12.8-17.46l2.92-4.56c1-1.52,1.87-3.09,2.8-4.63l1.39-2.33,1.32-2.36,1.33-2.36c.44-.79.88-1.58,1.3-2.38,3.44-6.34,6.63-12.83,9.66-19.38s5.81-13.22,8.52-19.92c5.37-13.41,10-27.1,14.29-40.91q3.17-10.37,5.93-20.86,1.39-5.23,2.68-10.5.63-2.64,1.23-5.28l.59-2.65.28-1.32c.08-.44.18-.9.24-1.3V197a.21.21,0,0,1,.24-.17.22.22,0,0,1,.16.17Z"
                    fill="#e3e2e3"
                />
                <path
                    id="Path_129"
                    d="M259.71,372.59s-56.33-147.83-41-259.76a9.59,9.59,0,0,1,15.72-6C273,139.79,377.8,248.22,259.71,372.59Z"
                    fill="#f4f5f6"
                />
                <path
                    id="Path_130"
                    d="M266.82,355.76a.42.42,0,0,0,.81.22c6.36-18.3,24.16-99.07-21.11-205.2a.293.293,0,0,0-.55.2C254.48,176.93,283.33,274.32,266.82,355.76Z"
                    fill="#e3e2e3"
                />
                <rect
                    id="Rectangle_89"
                    width="20.98"
                    height="96.23"
                    transform="translate(45.79 277.17)"
                    fill="#e3e2e3"
                />
                <rect
                    id="Rectangle_90"
                    width="20.98"
                    height="63.16"
                    transform="translate(80.84 310.24)"
                    fill="url(#linear-gradient-2)"
                />
                <rect
                    id="Rectangle_91"
                    width="20.98"
                    height="144.89"
                    transform="translate(115.89 228.51)"
                    fill="#e3e2e3"
                />
                <rect
                    id="Rectangle_92"
                    width="20.98"
                    height="34.81"
                    transform="translate(150.95 338.59)"
                    fill="#e3e2e3"
                />
                <rect
                    id="Rectangle_93"
                    width="20.98"
                    height="125.52"
                    transform="translate(186 247.88)"
                    fill="#e3e2e3"
                />
                <rect
                    id="Rectangle_94"
                    width="20.98"
                    height="103.79"
                    transform="translate(221.06 269.61)"
                    fill="#e3e2e3"
                />
                <rect
                    id="Rectangle_95"
                    width="20.98"
                    height="80.16"
                    transform="translate(256.11 293.23)"
                    fill="#e3e2e3"
                />
                <rect
                    id="Rectangle_96"
                    width="20.98"
                    height="174.18"
                    transform="translate(291.16 199.22)"
                    fill="#e3e2e3"
                />
                <rect
                    id="Rectangle_97"
                    width="20.98"
                    height="155.76"
                    transform="translate(326.22 217.64)"
                    fill="#e3e2e3"
                />
                <rect
                    id="Rectangle_98"
                    width="20.98"
                    height="127.88"
                    transform="translate(361.27 245.52)"
                    fill="#e3e2e3"
                />
                <rect
                    id="Rectangle_99"
                    width="20.98"
                    height="31.58"
                    transform="translate(396.33 341.82)"
                    fill="#e3e2e3"
                />
                <path
                    id="Path_131"
                    d="M6.25,277.8c12.1,3.25,81.71,25.06,73,94.06,0,0-49.52-2.56-74.28-92.76a1.06,1.06,0,0,1,1.28-1.3Z"
                    fill="#f4f5f6"
                />
                <path
                    id="Path_132"
                    d="M14.13,287.51c1.81,1.1,3.57,2.27,5.3,3.47s3.45,2.43,5.15,3.69q5.07,3.78,9.92,7.86a189,189,0,0,1,18.27,17.53c2.83,3.14,5.54,6.39,8.09,9.78a104.4,104.4,0,0,1,7,10.57,81.74,81.74,0,0,1,5.54,11.46,59.109,59.109,0,0,1,3.34,12.34.825.825,0,1,1-1.63.25h0a67.39,67.39,0,0,0-8.47-23.34,103.483,103.483,0,0,0-6.87-10.5c-2.49-3.37-5.14-6.63-7.92-9.77a188.115,188.115,0,0,0-18-17.6c-3.19-2.73-6.46-5.38-9.81-7.92-1.68-1.27-3.37-2.51-5.09-3.72s-3.46-2.39-5.23-3.5a.34.34,0,0,1-.12-.48.35.35,0,0,1,.53-.12Z"
                    fill="#e3e2e3"
                />
                <circle
                    id="Ellipse_10"
                    cx="74.55"
                    cy="74.55"
                    r="74.55"
                    transform="translate(259.636 166.691) rotate(-45)"
                    fill="#e3e2e3"
                />
                <circle
                    id="Ellipse_11"
                    cx="63.63"
                    cy="63.63"
                    r="63.63"
                    transform="translate(275.079 166.691) rotate(-45)"
                    fill="#707171"
                />
                <path
                    id="Path_133"
                    d="M365.06,232.58A65.9,65.9,0,1,1,431,166.69a65.9,65.9,0,0,1-65.94,65.89Zm0-127.26a61.37,61.37,0,1,0,61.36,61.367,61.372,61.372,0,0,0-61.36-61.367Z"
                    fill="#fff"
                />
                <circle
                    id="Ellipse_12"
                    cx="38.79"
                    cy="38.79"
                    r="38.79"
                    transform="translate(315.134 189.406) rotate(-69.46)"
                    fill="#f4f5f6"
                />
                <path
                    id="Path_134"
                    d="M365.06,207.74a41.06,41.06,0,1,1,41.06-41.057,41.06,41.06,0,0,1-41.06,41.057Zm0-77.58a36.53,36.53,0,1,0,36.53,36.53,36.53,36.53,0,0,0-36.53-36.53Z"
                    fill="#fff"
                />
                <circle
                    id="Ellipse_13"
                    cx="15.03"
                    cy="15.03"
                    r="15.03"
                    transform="translate(346.202 176.716) rotate(-73.74)"
                    fill="#707171"
                />
                <path
                    id="Path_135"
                    d="M365.06,184a17.3,17.3,0,1,1,17.29-17.293A17.3,17.3,0,0,1,365.06,184Zm0-30.06a12.78,12.78,0,1,0,0-.02Z"
                    fill="#fff"
                />
                <rect
                    id="Rectangle_100"
                    width="1.91"
                    height="72.49"
                    transform="translate(375.94 158.927) rotate(-135)"
                    fill="#e3e2e3"
                />
                <path
                    id="Path_136"
                    d="M376.93,152.93c.86-.86,4.52,2.8,3.66,3.67l-14.92,12a.534.534,0,1,1-.76-.75Z"
                    fill="#fff"
                />
                <path
                    id="Path_137"
                    d="M427.18,107.7l6.89.69-9.47,9.46a14.62,14.62,0,0,1-11.79,4.22h0Z"
                    fill="#707171"
                />
                <path
                    id="Path_138"
                    d="M425.82,106.35l-.68-6.9-9.47,9.47a14.65,14.65,0,0,0-4.22,11.79h0Z"
                    fill="#707171"
                />
                <circle
                    id="Ellipse_14"
                    cx="31.07"
                    cy="31.07"
                    r="31.07"
                    transform="matrix(0.27, -0.963, 0.963, 0.27, 177.046, 187.63)"
                    fill="#e3e2e3"
                />
                <circle
                    id="Ellipse_15"
                    cx="30.04"
                    cy="30.04"
                    r="30.04"
                    transform="translate(180.28 142.11) rotate(-10.62)"
                    fill="#707171"
                />
                <path
                    id="Path_139"
                    d="M190.57,154a.43.43,0,0,1-.19,0,.42.42,0,0,1-.18-.56A28,28,0,0,1,215.34,138a28.619,28.619,0,0,1,5.07.45.41.41,0,0,1,.33.48.4.4,0,0,1-.47.33,28.07,28.07,0,0,0-4.93-.44,27.19,27.19,0,0,0-24.4,15,.42.42,0,0,1-.37.18Z"
                    fill="#f4f5f6"
                />
                <circle
                    id="Ellipse_16"
                    cx="25.42"
                    cy="25.42"
                    r="25.42"
                    transform="matrix(0.058, -0.998, 0.998, 0.058, 189.137, 190.659)"
                    fill="#fff"
                />
                <path
                    id="Path_140"
                    d="M213.5,185.65v-2.76a22.509,22.509,0,0,1-7.76-1.69,1.59,1.59,0,0,1-.89-1.89l.7-2.57a1.61,1.61,0,0,1,2.19-1.06,18.78,18.78,0,0,0,7.17,1.51c2.78,0,4.85-.94,4.85-2.87,0-1.74-1.6-2.78-5.46-3.81-5.51-1.51-9.46-3.91-9.46-8.76,0-4.38,3.2-7.72,8.75-8.61v-2.77a1.61,1.61,0,0,1,1.61-1.61h1.63a1.61,1.61,0,0,1,1.61,1.61v2.48a20.67,20.67,0,0,1,6.15,1.11,1.6,1.6,0,0,1,1,1.93l-.64,2.39a1.6,1.6,0,0,1-2.12,1.08,17,17,0,0,0-6-1.09c-3.29,0-4.23,1.36-4.23,2.59,0,1.5,2,2.54,6.26,3.86,6.12,1.83,8.66,4.37,8.66,8.94,0,4.19-3.11,8-9.13,8.9v3.09a1.62,1.62,0,0,1-1.62,1.61h-1.62a1.61,1.61,0,0,1-1.65-1.61Z"
                    fill="#707171"
                />
                <circle
                    id="Ellipse_17"
                    cx="31.07"
                    cy="31.07"
                    r="31.07"
                    transform="translate(219.56 186.118) rotate(-72.08)"
                    fill="#e3e2e3"
                />
                <circle
                    id="Ellipse_18"
                    cx="30.04"
                    cy="30.04"
                    r="30.04"
                    transform="translate(216.429 170.578) rotate(-51.02)"
                    fill="#707171"
                />
                <path
                    id="Path_141"
                    d="M233.9,154a.39.39,0,0,1-.18,0,.4.4,0,0,1-.18-.56A28,28,0,0,1,258.67,138a28.73,28.73,0,0,1,5.08.45.42.42,0,0,1,.33.48.41.41,0,0,1-.48.33,27.9,27.9,0,0,0-4.93-.44,27.21,27.21,0,0,0-24.4,15,.41.41,0,0,1-.37.18Z"
                    fill="#f4f5f6"
                />
                <circle
                    id="Ellipse_19"
                    cx="25.42"
                    cy="25.42"
                    r="25.42"
                    transform="translate(233.137 191.378) rotate(-88.26)"
                    fill="#fff"
                />
                <path
                    id="Path_142"
                    d="M256.83,185.65v-2.76a22.62,22.62,0,0,1-7.76-1.69,1.6,1.6,0,0,1-.88-1.89l.7-2.57a1.61,1.61,0,0,1,2.19-1.06,18.77,18.77,0,0,0,7.16,1.51c2.78,0,4.85-.94,4.85-2.87,0-1.74-1.6-2.78-5.46-3.81-5.51-1.51-9.46-3.91-9.46-8.76,0-4.38,3.2-7.72,8.76-8.61v-2.77a1.61,1.61,0,0,1,1.61-1.61h1.62a1.61,1.61,0,0,1,1.61,1.61v2.48a20.8,20.8,0,0,1,6.16,1.11,1.61,1.61,0,0,1,1,1.93l-.65,2.39a1.6,1.6,0,0,1-2.12,1.08,17,17,0,0,0-6-1.09c-3.3,0-4.24,1.36-4.24,2.59,0,1.5,2,2.54,6.26,3.86,6.12,1.83,8.66,4.37,8.66,8.94,0,4.19-3.11,8-9.13,8.9v3.09a1.61,1.61,0,0,1-1.61,1.61h-1.63a1.61,1.61,0,0,1-1.64-1.61Z"
                    fill="#707171"
                />
                <circle
                    id="Ellipse_20"
                    cx="36.84"
                    cy="36.84"
                    r="36.84"
                    transform="translate(259.071 195.598) rotate(-79.49)"
                    fill="#e3e2e3"
                />
                <circle
                    id="Ellipse_21"
                    cx="35.62"
                    cy="35.62"
                    r="35.62"
                    transform="translate(254.014 181.357) rotate(-62.62)"
                    fill="#707171"
                />
                <path
                    id="Path_143"
                    d="M272.64,151.71a.349.349,0,0,1-.37-.55A33.13,33.13,0,0,1,302,132.81a33.47,33.47,0,0,1,6,.54.412.412,0,0,1-.15.81,32.719,32.719,0,0,0-5.85-.53,32.34,32.34,0,0,0-29,17.86.4.4,0,0,1-.36.22Z"
                    fill="#f4f5f6"
                />
                <circle
                    id="Ellipse_22"
                    cx="30.15"
                    cy="30.15"
                    r="30.15"
                    transform="matrix(0.137, -0.991, 0.991, 0.137, 268.795, 192.628)"
                    fill="#fff"
                />
                <path
                    id="Path_144"
                    d="M299.82,189.28V186a26.59,26.59,0,0,1-9.2-2,1.9,1.9,0,0,1-1.05-2.24l.84-3.06a1.9,1.9,0,0,1,2.59-1.25,22.2,22.2,0,0,0,8.5,1.79c3.29,0,5.75-1.12,5.75-3.4,0-2.07-1.9-3.3-6.48-4.52-6.53-1.79-11.22-4.64-11.22-10.39,0-5.19,3.8-9.15,10.39-10.21v-3.28a1.9,1.9,0,0,1,1.91-1.91h1.92a1.9,1.9,0,0,1,1.91,1.91v2.94a24.58,24.58,0,0,1,7.3,1.31,1.91,1.91,0,0,1,1.19,2.3l-.77,2.82a1.91,1.91,0,0,1-2.52,1.29,20,20,0,0,0-7.15-1.3c-3.91,0-5,1.62-5,3.07,0,1.79,2.34,3,7.42,4.58,7.26,2.18,10.27,5.19,10.27,10.6,0,5-3.68,9.44-10.83,10.55v3.67a1.91,1.91,0,0,1-1.91,1.92h-1.93a1.92,1.92,0,0,1-1.93-1.91Z"
                    fill="#707171"
                />
                <path
                    id="Path_145"
                    d="M105,370.31H69.59V236.53a28.14,28.14,0,0,1,28.12-28.11H212.36a28.14,28.14,0,0,1,28.11,28.11v62.13H352.06v-49h35.41V306a28.15,28.15,0,0,1-28.11,28.12H233.18A28.15,28.15,0,0,1,205.06,306V243.83H105Z"
                    fill="#707171"
                />
                <rect
                    id="Rectangle_101"
                    width="42.41"
                    height="6.59"
                    rx="1.66"
                    transform="translate(66.09 366.81)"
                    fill="#707171"
                />
                <rect
                    id="Rectangle_102"
                    width="42.41"
                    height="6.59"
                    rx="1.66"
                    transform="translate(66.09 242.05)"
                    fill="#f4f5f6"
                />
                <rect
                    id="Rectangle_103"
                    width="42.41"
                    height="6.59"
                    rx="1.66"
                    transform="translate(348.15 246.58)"
                    fill="#f4f5f6"
                />
                <rect
                    id="Rectangle_104"
                    width="42.41"
                    height="6.59"
                    rx="1.66"
                    transform="translate(200.74 293.52)"
                    fill="#f4f5f6"
                />
                <rect
                    id="Rectangle_105"
                    width="42.41"
                    height="6.59"
                    rx="1.66"
                    transform="translate(348.56 293.52)"
                    fill="#f4f5f6"
                />
                <path
                    id="Path_146"
                    d="M355.15,296.81v35.82a3.3,3.3,0,0,1-3.3,3.3h0a3.29,3.29,0,0,1-3.29-3.3V296.81a3.29,3.29,0,0,1,3.29-3.29h0a3.29,3.29,0,0,1,3.3,3.29Z"
                    fill="#f4f5f6"
                />
                <path
                    id="Path_147"
                    d="M243.15,296.81v35.82a3.3,3.3,0,0,1-3.3,3.3h0a3.3,3.3,0,0,1-3.29-3.3V296.81a3.29,3.29,0,0,1,3.29-3.29h0a3.29,3.29,0,0,1,3.3,3.29Z"
                    fill="#f4f5f6"
                />
                <path
                    id="Path_148"
                    d="M207.33,209.52v35.82a3.3,3.3,0,0,1-3.3,3.3h0a3.29,3.29,0,0,1-3.29-3.3V209.52a3.29,3.29,0,0,1,3.29-3.3h0A3.3,3.3,0,0,1,207.33,209.52Z"
                    fill="#f4f5f6"
                />
                <path
                    id="Path_149"
                    d="M108.5,209.52v35.82a3.29,3.29,0,0,1-3.29,3.3h0a3.29,3.29,0,0,1-3.29-3.3V209.52a3.29,3.29,0,0,1,3.29-3.3h0a3.29,3.29,0,0,1,3.29,3.3Z"
                    fill="#f4f5f6"
                />
                <rect
                    id="Rectangle_106"
                    width="42.41"
                    height="6.59"
                    rx="1.66"
                    transform="translate(200.74 242.05)"
                    fill="#f4f5f6"
                />
                <path
                    id="Path_150"
                    d="M276.87,318.26s17.65-30.87,20-33.77a1.83,1.83,0,0,1,1.65-.66l4.92.58,5.78,12.5-9.63-5.6c.95,6.58-11.41,16.37-15.65,19.94a1,1,0,0,0-.08,1.42l1.69,1.78a19.46,19.46,0,0,1-9.6,5.46Z"
                    fill="#e3e2e3"
                />
                <path
                    id="Path_151"
                    d="M284.61,313.49a2.48,2.48,0,0,1,1.44,1.31,1.1,1.1,0,0,1-.41,1.27c-1.78,1.27-7.65,5.39-10.36,6.19a.3.3,0,0,1-.38-.36,9.77,9.77,0,0,1,2-3.72l-.13.26a.38.38,0,0,0,.52.5C279.14,317.92,282.83,315.68,284.61,313.49Z"
                    fill="#474747"
                />
                <path
                    id="Path_152"
                    d="M283.73,325.83s2.68-6.38,2.71-6.4a111.689,111.689,0,0,1,10.08-30.72,1.83,1.83,0,0,1,1.48-1l4.93-.43,8.19,11.08-10.56-3.55c2.26,6.26-7.86,18.35-11.29,22.71a1,1,0,0,0,.21,1.4l2,1.39a19.42,19.42,0,0,1-8.3,7.3Z"
                    fill="#e3e2e3"
                />
                <path
                    id="Path_153"
                    d="M290.34,319.59a2.51,2.51,0,0,1,1.68,1,1.09,1.09,0,0,1-.14,1.32c-1.49,1.61-6.4,6.83-8.89,8.17a.31.31,0,0,1-.45-.28,9.71,9.71,0,0,1,1.24-4.06l-.07.28a.37.37,0,0,0,.61.38C285.88,325,289,322.1,290.34,319.59Z"
                    fill="#474747"
                />
                <path
                    id="Path_154"
                    d="M326,285s4.46,6.64,4.83,9.67-1.23,4.08-5.91,4.46c-13.9,1.15-20.75-3-20.75-3-1-6.07-1.63-7.61-9.58-10.91,0,0,10.05.8,12.07,0S326,285,326,285Z"
                    fill="#474747"
                />
                <path
                    id="Path_155"
                    d="M314,284.09a102.879,102.879,0,0,1-7.76-8.22,7,7,0,0,1-1.18-6.26,85.4,85.4,0,0,1,3.44-8.65c.29-1,6.11-.93,6.11-.93s11.47,7.44,16,20.05l-5.06,1.58a58.585,58.585,0,0,0-5.95-8.22s5.12,6.76,5.3,9.53Z"
                    fill="#707171"
                />
                <path
                    id="Path_156"
                    d="M307.75,255.52c.06.21,1.58,5.25,1.7,5.35s3.34.28,4.85-.75l-3.09-6.84Z"
                    fill="#e3e2e3"
                />
                <path
                    id="Path_157"
                    d="M303.57,249.86a9.33,9.33,0,0,0,.19,6.3c1.27,3.81,3.35,4.14,4.67,3.2a7.51,7.51,0,0,0,3.23-6.07C311.87,249.85,305.06,246.69,303.57,249.86Z"
                    fill="#f4f5f6"
                />
                <path
                    id="Path_158"
                    d="M309.09,253.07s-2.3-5.15-5.74-1.94l-.27,1.32s-3.28-.93-2.2-3.91a6,6,0,0,1,8.51-3.06c3.51,1.93,4.7,4.2,4.52,6.9s-2.22,1.79-2.22,1.79-.39-2-1.35-2.35-.93,1.15-.93,1.15Z"
                    fill="#707171"
                />
                <path
                    id="Path_159"
                    d="M309.88,253.55s-1.19-2.64.48-2.74,1,2.54.66,3.51Z"
                    fill="#f4f5f6"
                />
                <path
                    id="Path_160"
                    d="M304.05,286.05,308,281.8l4.51,1.21s5.26.82,8.27,0l3-.81,6.8-2.12,1.07,3a1.81,1.81,0,0,1-.67,2.09,11.172,11.172,0,0,1-1.71,1.07c-.9.39-20.64.12-20.64.12Z"
                    fill="#f4f5f6"
                />
                <path
                    id="Path_161"
                    d="M310.83,247.39a1.18,1.18,0,0,1-.67-2c2.06-2.25,5.95-4.75,11.5-.91,6.24,4.32,9.62,6.27,11.16,5.86a1.19,1.19,0,0,1,1.41,1.66,5.07,5.07,0,0,1-2.4,2C321.62,259.11,316.34,248.06,310.83,247.39Z"
                    fill="#707171"
                />
                <path
                    id="Path_162"
                    d="M317,287.73H299a.81.81,0,1,1,0-1.61h18a.81.81,0,0,1,0,1.61Z"
                    fill="#707171"
                />
                <path
                    id="Path_163"
                    d="M282.82,271.42h15a2.86,2.86,0,0,1,2.58,1.63l6.91,14.67H288.69a1.72,1.72,0,0,1-1.61-1.1l-5.37-13.57a1.19,1.19,0,0,1,1.11-1.63Z"
                    fill="#707171"
                />
                <path
                    id="Path_164"
                    d="M293.37,278.94c.32,1,.08,2-.54,2.18s-1.38-.45-1.71-1.46-.08-2,.54-2.19S293,277.93,293.37,278.94Z"
                    fill="#e3e2e3"
                />
                <path
                    id="Path_165"
                    d="M176.57,294.49s-.38,2.15-.56,4.28a1.47,1.47,0,0,0,1.4,1.6c2.84.11,8.91.34,11.09.25a.48.48,0,0,0,.42-.66h0a1.06,1.06,0,0,0-.55-.57l-10-4.61Z"
                    fill="#707171"
                />
                <path
                    id="Path_166"
                    d="M176.26,293.23l.31,2.57a3.271,3.271,0,0,0,3-.1l-.72-2.87Z"
                    fill="#e3e2e3"
                />
                <path
                    id="Path_167"
                    d="M176.49,244.8c-.13.68-.71,33.57,2.81,48.31a.5.5,0,0,1-.29.58,8.7,8.7,0,0,1-2.87.58.86.86,0,0,1-.85-.62c-1-3.42-5.82-20.55-6.45-36.92-.7-18.29,0-.62,0-.62l.41-11.31Z"
                    fill="#707171"
                />
                <path
                    id="Path_168"
                    d="M165,295.61a15.47,15.47,0,0,0-1.2,4,.9.9,0,0,0,.79,1.07c.94.09,2.38.21,3.54.2a.88.88,0,0,0,.88-1,7.38,7.38,0,0,0-1.76-4.13Z"
                    fill="#707171"
                />
                <path
                    id="Path_169"
                    d="M164.5,292.3l.72,3.9a2.52,2.52,0,0,0,2.1.14l-.34-4.19Z"
                    fill="#e3e2e3"
                />
                <path
                    id="Path_170"
                    d="M162.58,245.81c-2.88,17.36.62,42.89,1.8,47.89a.77.77,0,0,0,.63.59,5.17,5.17,0,0,0,2.25-.09.71.71,0,0,0,.51-.65c.16-4-.13-28.85,2.55-38.66a2.22,2.22,0,0,1,.86-1.22l5.2-3.7.4-6Z"
                    fill="#707171"
                />
                <path
                    id="Path_171"
                    d="M180.9,212.93a81.281,81.281,0,0,0-18.13,2.26c-2.57,15-.45,32.28-.45,32.28,6.67,1.75,14.2-1.07,14.2-1.07,1.11-6.27,6.28-23.9,6.28-23.9a28.32,28.32,0,0,0,10.54-3.34,18.35,18.35,0,0,1-3.65-7.64,29,29,0,0,1-8.79,1.41Z"
                    fill="#474747"
                />
                <path
                    id="Path_172"
                    d="M206.35,200.24a1.66,1.66,0,0,0-1.92-.54c-1.26,5.36-7.91,9.7-14.74,11.82a18.35,18.35,0,0,0,3.65,7.64C204.67,212.79,206.35,200.24,206.35,200.24Z"
                    fill="#e3e2e3"
                />
                <path
                    id="Path_173"
                    d="M206.15,200.5c.09.28-.94.71-1.54-.44,0-.56-.36-2.92,0-3.37a44.9,44.9,0,0,1,5.16-5.4.81.81,0,0,1,.1,1.13l-1.65,1.72a7.439,7.439,0,0,1,1,1.91,2.3,2.3,0,0,1-.23,1.7,19.188,19.188,0,0,1-1.06,1.73,2.27,2.27,0,0,1-1.78,1.02Z"
                    fill="#e3e2e3"
                />
                <path
                    id="Path_174"
                    d="M207.47,195.26,206,196.53l-.47,1.27,1.34,1.49a16.819,16.819,0,0,1,.79-3.06C208,195.68,207.78,195.42,207.47,195.26Z"
                    fill="#f4f5f6"
                />
                <path
                    id="Path_175"
                    d="M166.08,223.54l-3.31-8.35s-8.05,5.47-9.37,12.41a19,19,0,0,1,7,1.87C161,226.2,166.08,223.54,166.08,223.54Z"
                    fill="#474747"
                />
                <path
                    id="Path_176"
                    d="M173.11,231.39s-9,5.11-12.08.75a3.4,3.4,0,0,1-.63-2.67,19,19,0,0,0-7-1.87,9.56,9.56,0,0,0,1,6.56c5.34,9.77,19.87-.54,19.87-.54Z"
                    fill="#e3e2e3"
                />
                <path
                    id="Path_177"
                    d="M172,237.85l5-17.22a.5.5,0,0,1,.42-.37c.9-.1,3.49-.39,6.48-.65a74.1,74.1,0,0,1,10.28-.34.51.51,0,0,1,.41.73c-1.42,2.87-7.27,14.57-10.19,18.4a.51.51,0,0,1-.41.2l-11.44-.11a.49.49,0,0,1-.55-.64Z"
                    fill="#f4f5f6"
                />
                <path
                    id="Path_178"
                    d="M184.37,218.12l3.57-.59a.26.26,0,0,1,.29.33l-.36,1.07a.26.26,0,0,1-.2.18l-3.45.46a.26.26,0,0,1-.28-.32l.22-.93A.26.26,0,0,1,184.37,218.12Z"
                    fill="#707171"
                />
                <path
                    id="Path_179"
                    d="M181.69,221.15l.29-1.54a.35.35,0,0,1,.32-.28l7.22-.73a.35.35,0,0,1,.38.43l-.46,1.91a.34.34,0,0,1-.33.27l-7.05.36a.36.36,0,0,1-.37-.42Z"
                    fill="#707171"
                />
                <path
                    id="Path_180"
                    d="M173.22,233.69s-.69-2.83-.41-3.83.81-2.29,2.6-2a25.332,25.332,0,0,1,3.9,1,1,1,0,0,1-1.46.88l.84.65s-.12,1-1.27.49l.78.87a.9.9,0,0,1-1.33.3C176,231.54,175.61,234,173.22,233.69Z"
                    fill="#e3e2e3"
                />
                <path
                    id="Path_181"
                    d="M172.17,205.93l-2.74,7.93a.29.29,0,0,0,.13.35,6.44,6.44,0,0,0,6.68-.45,1.36,1.36,0,0,0,.62-1l.89-6.87Z"
                    fill="#e3e2e3"
                />
                <path
                    id="Path_182"
                    d="M178.14,198.59s3,5.67,2.62,8-4.12,2.12-7.38.26l-2.27-6.12Z"
                    fill="#e3e2e3"
                />
                <path
                    id="Path_183"
                    d="M173.53,203.81a.23.23,0,0,0,.1-.34,6.29,6.29,0,0,1-.84-1.78s-.54-.35,1.38-.81,4.78-1.17,5.38-2.8-1-5.6-3.41-2.41a.23.23,0,0,1-.37,0,2.41,2.41,0,0,0-2.93-.95,2.22,2.22,0,0,0-1.52,2.14.22.22,0,0,1-.27.23,2.71,2.71,0,0,0-3.15,1.47c-.64,1.41-.22,2.21.16,2.6a.24.24,0,0,1-.1.39,1.39,1.39,0,0,0-1,1.6c.08,1.48,1.74,1.35,2.21,1.28a.27.27,0,0,1,.21.07c.4.45,2.22,2.35,4.19,2.58a.23.23,0,0,0,.25-.31l-.85-2.48a.23.23,0,0,1,.13-.29Z"
                    fill="#707171"
                />
                <path
                    id="Path_184"
                    d="M173.87,204.16s-2.14-1.47-2.3-.23,1.93,1.79,3,1.33Z"
                    fill="#e3e2e3"
                />
                <path
                    id="Path_185"
                    d="M192.68,373c-.48,0-.87-.27-.87-.6v-71c0-.33.39-.6.87-.6s.88.27.88.6v71C193.56,372.68,193.17,373,192.68,373Z"
                    fill="#474747"
                />
                <path
                    id="Path_186"
                    d="M169,373c-.49,0-.88-.27-.88-.6v-71c0-.33.39-.6.88-.6s.87.27.87.6v71A.89.89,0,0,1,169,373Z"
                    fill="#474747"
                />
                <path
                    id="Path_187"
                    d="M110.67,373.4a1.34,1.34,0,0,1-.35,0c-.44-.13-.65-.48-.46-.78l44.77-71.46a1,1,0,0,1,1.15-.32c.44.13.65.48.46.78L111.47,373a1,1,0,0,1-.8.4Z"
                    fill="#707171"
                />
                <path
                    id="Path_188"
                    d="M138.32,373.4a1.329,1.329,0,0,1-.34,0c-.45-.13-.65-.48-.47-.78l44.78-71.46a1,1,0,0,1,1.14-.32c.45.13.66.48.47.78L139.13,373A1,1,0,0,1,138.32,373.4Z"
                    fill="#707171"
                />
                <path
                    id="Path_189"
                    d="M194.44,302H152.63a.83.83,0,0,1-.83-.84h0a.83.83,0,0,1,.83-.83h41.81a.84.84,0,0,1,.84.83h0a.84.84,0,0,1-.84.84Z"
                    fill="#707171"
                />
                <path
                    id="Path_190"
                    d="M176.33,312.86H148.59c-.48,0-.87-.27-.87-.59s.39-.6.87-.6h27.74c.48,0,.87.27.87.6S176.81,312.86,176.33,312.86Z"
                    fill="#707171"
                />
                <rect
                    id="Rectangle_107"
                    width="27.74"
                    height="1.19"
                    transform="translate(140.08 325.19)"
                    fill="#707171"
                />
                <rect
                    id="Rectangle_108"
                    width="27.74"
                    height="1.19"
                    transform="translate(131.84 338.7)"
                    fill="#707171"
                />
                <path
                    id="Path_191"
                    d="M150.94,353.41H123.2c-.48,0-.87-.27-.87-.6s.39-.59.87-.59h27.74c.48,0,.87.27.87.59S151.42,353.41,150.94,353.41Z"
                    fill="#707171"
                />
                <path
                    id="Path_192"
                    d="M142.58,366.92H114.85c-.49,0-.88-.26-.88-.59s.39-.59.88-.59h27.73c.49,0,.88.26.88.59S143.07,366.92,142.58,366.92Z"
                    fill="#707171"
                />
                <path
                    id="Path_193"
                    d="M163.54,156a1.92,1.92,0,1,0,1.91-1.93A1.92,1.92,0,0,0,163.54,156Z"
                    fill="#e3e2e3"
                />
                <path
                    id="Path_194"
                    d="M163.61,156a1.86,1.86,0,1,0,1.84-1.86,1.86,1.86,0,0,0-1.84,1.86Z"
                    fill="#e3e2e3"
                />
                <path
                    id="Path_195"
                    d="M167.17,156.28a.41.41,0,0,1-.41-.39.883.883,0,0,0,0-.16.42.42,0,0,1,.33-.48.4.4,0,0,1,.48.33,1.09,1.09,0,0,1,0,.26.41.41,0,0,1-.38.44Z"
                    fill="#e3e2e3"
                />
                <path
                    id="Path_196"
                    d="M167,155.6a.41.41,0,0,1-.37-.22,1.29,1.29,0,0,0-1.16-.71h-.23a.4.4,0,0,1-.48-.33.41.41,0,0,1,.33-.48,2.339,2.339,0,0,1,.38,0h0a2.11,2.11,0,0,1,1.89,1.15.41.41,0,0,1-.17.56.43.43,0,0,1-.19.03Z"
                    fill="#707171"
                />
                <circle
                    id="Ellipse_23"
                    cx="1.92"
                    cy="1.92"
                    r="1.92"
                    transform="translate(163.54 165.68)"
                    fill="#e3e2e3"
                />
                <path
                    id="Path_197"
                    d="M163.61,167.61a1.86,1.86,0,1,0,1.84-1.86,1.86,1.86,0,0,0-1.84,1.86Z"
                    fill="#e3e2e3"
                />
                <path
                    id="Path_198"
                    d="M167.17,167.91a.41.41,0,0,1-.41-.39.883.883,0,0,0,0-.16.42.42,0,0,1,.33-.48.41.41,0,0,1,.48.33,1.15,1.15,0,0,1,0,.26.41.41,0,0,1-.38.44Z"
                    fill="#e3e2e3"
                />
                <path
                    id="Path_199"
                    d="M167,167.23a.41.41,0,0,1-.37-.22,1.33,1.33,0,0,0-1.17-.71h-.23a.4.4,0,0,1-.48-.32.42.42,0,0,1,.33-.49,2.341,2.341,0,0,1,.38,0,2.1,2.1,0,0,1,1.9,1.15.41.41,0,0,1-.17.56A.43.43,0,0,1,167,167.23Z"
                    fill="#707171"
                />
                <path
                    id="Path_200"
                    d="M163.54,179.25a1.92,1.92,0,1,0,.552-1.367A1.92,1.92,0,0,0,163.54,179.25Z"
                    fill="#e3e2e3"
                />
                <path
                    id="Path_201"
                    d="M163.61,179.25a1.85,1.85,0,1,0,.531-1.318,1.86,1.86,0,0,0-.531,1.318Z"
                    fill="#e3e2e3"
                />
                <path
                    id="Path_202"
                    d="M167.17,179.54a.41.41,0,0,1-.41-.38,1,1,0,0,0,0-.17.42.42,0,0,1,.33-.48.41.41,0,0,1,.48.33,1.24,1.24,0,0,1,0,.27.4.4,0,0,1-.38.43Z"
                    fill="#e3e2e3"
                />
                <path
                    id="Path_203"
                    d="M167,178.86a.41.41,0,0,1-.37-.22,1.31,1.31,0,0,0-1.17-.71.911.911,0,0,0-.23,0,.42.42,0,0,1-.48-.33.4.4,0,0,1,.33-.48,1.58,1.58,0,0,1,.38,0h0a2.11,2.11,0,0,1,1.89,1.15.41.41,0,0,1-.17.56.43.43,0,0,1-.18.03Z"
                    fill="#707171"
                />
                <path
                    id="Path_204"
                    d="M160.59,155.88v.33a1.47,1.47,0,0,1-1.25,1.59l-51.39.08a1.5,1.5,0,0,1-1.26-1.65h0a1.51,1.51,0,0,1,1.23-1.65l51.4-.4C160,154.16,160.62,154.94,160.59,155.88Z"
                    fill="#e3e2e3"
                />
                <path
                    id="Path_205"
                    d="M160.59,167.46v.32a1.47,1.47,0,0,1-1.25,1.59l-51.39.08a1.494,1.494,0,0,1-1.26-1.65h0a1.49,1.49,0,0,1,1.23-1.64l51.4-.41C160,165.73,160.62,166.51,160.59,167.46Z"
                    fill="#e3e2e3"
                />
                <path
                    id="Path_206"
                    d="M160.59,179v.33a1.47,1.47,0,0,1-1.25,1.59l-51.39.08a1.5,1.5,0,0,1-1.26-1.65h0a1.51,1.51,0,0,1,1.23-1.65l51.4-.4A1.552,1.552,0,0,1,160.59,179Z"
                    fill="#e3e2e3"
                />
                <circle
                    id="Ellipse_24"
                    cx="33.31"
                    cy="33.31"
                    r="33.31"
                    transform="translate(76.88 228.09)"
                    fill="#e3e2e3"
                />
                <circle
                    id="Ellipse_25"
                    cx="32.2"
                    cy="32.2"
                    r="32.2"
                    transform="translate(77.99 229.2)"
                    fill="#707171"
                />
                <path
                    id="Path_207"
                    d="M139.88,260.13h0a.3.3,0,0,0,.29-.32,29.8,29.8,0,0,0-.43-3.77.31.31,0,1,0-.6.11,28.351,28.351,0,0,1,.42,3.69.32.32,0,0,0,.32.29Z"
                    fill="#f4f5f6"
                />
                <path
                    id="Path_208"
                    d="M136.75,248.33a.3.3,0,0,0,.27-.44,29.9,29.9,0,0,0-26.83-16.52,30.583,30.583,0,0,0-5.41.49.31.31,0,1,0,.11.6,29.44,29.44,0,0,1,31.58,15.7.32.32,0,0,0,.28.17Z"
                    fill="#f4f5f6"
                />
                <circle
                    id="Ellipse_26"
                    cx="27.25"
                    cy="27.25"
                    r="27.25"
                    transform="matrix(0.994, -0.113, 0.113, 0.994, 79.337, 238.11)"
                    fill="#fff"
                />
                <path
                    id="Path_209"
                    d="M101.15,251.81c0,4.61,3.74,9.59,8.35,9.59s8.36-5,8.36-9.59-3.74-7.89-8.36-7.89S101.15,247.19,101.15,251.81Z"
                    fill="#707171"
                />
                <path
                    id="Path_210"
                    d="M119.87,279.17H99.48a5,5,0,0,1-4.71-3.43l-1.09-3.43a4.93,4.93,0,0,1,3-6.14c8.3-3,16.88-2.65,25.67.28a4.91,4.91,0,0,1,3.15,6l-.84,3.12a4.94,4.94,0,0,1-4.79,3.6Z"
                    fill="#707171"
                />
                <path
                    id="Path_211"
                    d="M78.16,272.41l.06-1.92-2-4a2.57,2.57,0,0,1,0-2.31l2.26-4.57s1.31,9.92,1.66,10.74-.94,2.31-.94,2.31Z"
                    fill="#e3e2e3"
                />
                <path
                    id="Path_212"
                    d="M56,278.23s-2.13,1-2.53,2.23c-.31,1-2.67,1.08-2.91,3a2.15,2.15,0,0,1-1.81,1.9c-2.41.37-6.13,1.63-6.72,5.81-.46,3.2,1.17,4.41,2.89,4.83a2.42,2.42,0,0,1,1.83,2.8c-.24,1.22.12,2.63,2.23,3.74,4.72,2.49,9.44-5.91,9.44-5.91l1-14.66Z"
                    fill="#707171"
                />
                <path
                    id="Path_213"
                    d="M78.22,270.49s-6.08,16.57-16.44,21.75c0,0,3.45,5.62,5.25,6,0,0,11.06-14.15,12.19-25.75Z"
                    fill="#e3e2e3"
                />
                <path
                    id="Path_214"
                    d="M36.57,370.15l-.31,2.52c-.31,1.19-1.85,4.2-3.83,4-1.21-.12-1.36-3.66-1.19-4.19a9.3,9.3,0,0,1,1.69-3.29h2.79a.86.86,0,0,1,.85.96Z"
                    fill="#707171"
                />
                <path
                    id="Path_215"
                    d="M58.4,340.72l.47,2.77s-1.57,16-1.86,22.34a5,5,0,0,0,.75,2.84l2.73,4.45-7-4.11-.14-.85,1.14-1.56L53,348.72a5.49,5.49,0,0,1,.62-3L55.1,343Z"
                    fill="#e3e2e3"
                />
                <path
                    id="Path_216"
                    d="M61,373.77H58.73a1.35,1.35,0,0,1-1.06-.53c-.69-.9-2.13-2.65-2.81-2.7-.93-.06-.81,3.23-.81,3.23h-.52l-.65-4.09a2.4,2.4,0,0,1,1.26-2.52h0a3.45,3.45,0,0,0,1.36,2.25c1.14.69,4.66,3.17,4.66,3.17a3.3,3.3,0,0,1,.9,0,.6.6,0,0,1-.06,1.19Z"
                    fill="#707171"
                />
                <path
                    id="Path_217"
                    d="M48.86,342s-9.23,17.5-10.69,21.5a38.141,38.141,0,0,0-2,7.65c0,.49-.65,1-2.34,1a1.64,1.64,0,0,1-1.51-.68,1,1,0,0,1,0-1c.54-1.08,2.23-4.53,2.86-6.1.75-1.87,2.36-10.34,3.24-13.29s1.85-6.08,5.7-9.08C44.12,342,46.76,339.45,48.86,342Z"
                    fill="#e3e2e3"
                />
                <path
                    id="Path_218"
                    d="M54.69,313.35a17.64,17.64,0,0,0-1.43-12.7,4.29,4.29,0,0,1,1.8-5.86,33.146,33.146,0,0,1,6.72-2.55s6.62,4.84,5.83,8.62c-.46,2.22-4.65,13.29-4.65,13.29a9.19,9.19,0,0,1-8.27-.8Z"
                    fill="#707171"
                />
                <path
                    id="Path_219"
                    d="M49.42,318.34c1-2.92,5.27-5,5.27-5a9.19,9.19,0,0,0,8.27.8,16.6,16.6,0,0,1,.27,6.41c-.6,3.09-4.36,22.93-4.36,22.93-5.93,1.2-15-1.21-15-1.21C47.6,335.57,48.45,321.26,49.42,318.34Z"
                    fill="#474747"
                />
                <path
                    id="Path_220"
                    d="M57.46,285.57l-1.94,8.7c-.18.76.52.64,1.29.49,1.27-.24,2.9-.73,3.45-1.72a1.19,1.19,0,0,0,.1-.32l.83-6a1.08,1.08,0,0,0-.64-1.14l-1.6-.71a1.08,1.08,0,0,0-1.49.7Z"
                    fill="#f4f5f6"
                />
                <path
                    id="Path_221"
                    d="M59.73,277.29a8.59,8.59,0,0,1,3.85,4.29c1.56,3.31.39,4.84-1.07,5.05a6.84,6.84,0,0,1-6-2C54.24,282.53,56.75,276.15,59.73,277.29Z"
                    fill="#f4f5f6"
                />
                <path
                    id="Path_222"
                    d="M58.11,282.9s-1.73-4.85,2.56-4.91l1,.71s1.58-2.69-1-4-5.61-.19-6.67,3.3-1.29,5.82.54,7.49,2.59-.22,2.59-.22-1-1.56-.6-2.4,1.35.18,1.35.18Z"
                    fill="#707171"
                />
                <path id="Path_223" d="M58,283.67s-.87-2.5-2-1.5,1,2.3,1.77,2.73Z" fill="#f4f5f6" />
                <path
                    id="Path_224"
                    d="M81.65,279.83s-5.09,17.7-25.64,16a2.39,2.39,0,0,0-2.57,2.19v.71a3.16,3.16,0,0,0,3.31,3.41c6.83-.35,21.51-3,26.54-19.26Z"
                    fill="#e3e2e3"
                />
                <path
                    id="Path_225"
                    d="M83.24,282.91a32.449,32.449,0,0,0,1.22-4.68,15,15,0,0,0-1.44-7c-.77-1.14-.9,1.65-1.25,2.95a7,7,0,0,0,.24,3.18l-.36,2.45Z"
                    fill="#e3e2e3"
                />
                <path
                    id="Path_226"
                    d="M343.8,352.1h-1.24a.42.42,0,0,1-.41-.42.44.44,0,0,1,.42-.41h1.23a.41.41,0,0,1,0,.82Zm2.88,0a.42.42,0,0,1,0-.83h1.23a.41.41,0,0,1,.42.4.4.4,0,0,1-.4.42h-1.24Zm-7-.07h0l-1.24-.06a.42.42,0,0,1-.39-.44.4.4,0,0,1,.43-.38l1.23.05a.42.42,0,0,1,0,.83Zm11.11-.09a.415.415,0,0,1-.02-.83L352,351a.41.41,0,0,1,.44.38.4.4,0,0,1-.38.44l-1.24.08Zm-15.22-.16h-.26l-1-.09a.41.41,0,0,1-.38-.44.42.42,0,0,1,.45-.38l1,.09h.26a.41.41,0,1,1,0,.82Zm19.32-.14a.41.41,0,0,1,0-.82l1.22-.12a.412.412,0,1,1,.09.82l-1.24.12Zm-23.42-.26h-.05l-1.23-.15a.41.41,0,1,1,.11-.81l1.22.15a.41.41,0,0,1,.36.45.42.42,0,0,1-.4.34Zm27.52-.18a.411.411,0,1,1-.05-.82l1.22-.16a.42.42,0,0,1,.46.36.41.41,0,0,1-.35.46l-1.23.16Zm-31.6-.38h-.06l-1.22-.2a.4.4,0,0,1-.34-.47.41.41,0,0,1,.47-.34l1.22.19a.42.42,0,0,1,.34.47.41.41,0,0,1-.4.33Zm35.68-.19a.413.413,0,0,1-.07-.82l1.22-.19a.4.4,0,0,1,.47.34.41.41,0,0,1-.34.47l-1.22.2Zm-39.73-.51h-.08l-1.22-.24a.414.414,0,1,1,.17-.81l1.2.24a.41.41,0,0,1-.07.81Zm43.78-.18a.413.413,0,0,1-.07-.82l1.21-.23a.4.4,0,0,1,.48.32.42.42,0,0,1-.32.49l-1.22.23Zm-47.81-.65h-.09L318,349a.42.42,0,0,1-.31-.5.41.41,0,0,1,.5-.3l1.2.27a.42.42,0,0,1,.31.5.41.41,0,0,1-.38.3Zm51.85-.17a.42.42,0,0,1-.4-.33.41.41,0,0,1,.31-.49l1.2-.27a.416.416,0,0,1,.19.81l-1.21.27Zm-55.85-.8h-.11L314,348a.415.415,0,1,1,.22-.8l1.19.32a.4.4,0,0,1,.29.5.41.41,0,0,1-.38.28Zm59.86-.14a.42.42,0,0,1-.4-.32.4.4,0,0,1,.3-.49l1.19-.31a.414.414,0,1,1,.21.8l-1.2.3Zm-63.83-1a.25.25,0,0,1-.12,0l-1.19-.35a.4.4,0,0,1-.27-.51.41.41,0,0,1,.51-.28l1.18.35a.43.43,0,0,1,.28.52.42.42,0,0,1-.38.29Zm67.81-.1a.41.41,0,0,1-.11-.81l1.18-.33a.4.4,0,0,1,.51.28.41.41,0,0,1-.28.51l-1.19.34ZM307.41,346h-.13l-1.17-.39a.411.411,0,0,1,.26-.78l1.17.38a.42.42,0,0,1,.26.52.4.4,0,0,1-.39.27Zm75.7-.05a.41.41,0,0,1-.13-.81l1.18-.37a.414.414,0,1,1,.25.79l-1.18.37Zm-79.6-1.28h-.14l-1.16-.42a.41.41,0,0,1-.25-.53.42.42,0,0,1,.53-.25c.38.15.77.28,1.16.42a.42.42,0,0,1,.25.53.41.41,0,0,1-.39.24Zm83.51,0a.418.418,0,0,1-.14-.81l1.17-.4a.41.41,0,0,1,.27.77l-1.17.41a.31.31,0,0,1-.15.02Zm3.87-1.42a.42.42,0,0,1-.39-.26.41.41,0,0,1,.24-.53l1.15-.45a.41.41,0,0,1,.3.76l-1.15.46a.39.39,0,0,1-.15.01Zm-91.24,0a.4.4,0,0,1-.15,0c-.39-.14-.77-.29-1.16-.45a.41.41,0,1,1,.31-.76l1.14.45a.41.41,0,0,1-.14.79Zm-3.83-1.53h-.16l-1.14-.47a.412.412,0,0,1,.32-.76l1.14.47a.41.41,0,0,1,.22.54.4.4,0,0,1-.38.2Zm98.88,0a.41.41,0,0,1-.16-.79l1.13-.49a.41.41,0,0,1,.33.75l-1.14.5a.41.41,0,0,1-.16,0ZM292,340.09a.47.47,0,0,1-.16,0l-1.13-.5a.42.42,0,0,1-.21-.55.4.4,0,0,1,.54-.2l1.13.5a.41.41,0,0,1,.21.54A.43.43,0,0,1,292,340.09ZM398.45,340a.39.39,0,0,1-.37-.23.4.4,0,0,1,.19-.55l1.1-.54a.41.41,0,0,1,.37.73l-1.11.55a.39.39,0,0,1-.18.04Zm-110.17-1.6a.33.33,0,0,1-.17,0l-1.12-.52a.42.42,0,0,1-.2-.55.41.41,0,0,1,.55-.2l1.12.53a.41.41,0,0,1-.18.78Zm113.83-.28a.4.4,0,0,1-.36-.21.42.42,0,0,1,.16-.56l1.08-.6a.412.412,0,1,1,.4.72l-1.08.6a.35.35,0,0,1-.2.03Zm-117.54-1.5a.39.39,0,0,1-.18,0l-1.11-.55a.414.414,0,1,1,.37-.74l1.1.55a.41.41,0,0,1-.18.78ZM405.68,336a.41.41,0,0,1-.35-.19.42.42,0,0,1,.13-.57l1-.65a.41.41,0,1,1,.44.69l-1.05.66a.421.421,0,0,1-.17.06Zm-124.79-1.3a.43.43,0,0,1-.19,0l-1.09-.57a.411.411,0,1,1,.38-.73l1.09.57a.41.41,0,0,1-.19.77Zm128.23-1a.42.42,0,0,1-.34-.17.41.41,0,0,1,.1-.57l1-.72a.41.41,0,0,1,.57.09.42.42,0,0,1-.09.58l-1,.72a.44.44,0,0,1-.24.15Zm-131.87-1a.41.41,0,0,1-.19-.05c-.37-.19-.73-.39-1.09-.59a.41.41,0,1,1,.39-.72l1.09.59a.41.41,0,0,1-.2.77Zm135.17-1.5a.41.41,0,0,1-.32-.15.42.42,0,0,1,.06-.58l1-.77a.4.4,0,0,1,.58.05.41.41,0,0,1-.06.58l-1,.78a.43.43,0,0,1-.26.21Zm-138.78-.48a.39.39,0,0,1-.2-.06l-1.08-.6a.43.43,0,0,1-.15-.57.42.42,0,0,1,.56-.15l1.08.61a.42.42,0,0,1,.15.56.41.41,0,0,1-.36.33Zm-3.57-2a.41.41,0,0,1-.21-.05l-1.07-.63a.4.4,0,0,1-.14-.56.41.41,0,0,1,.56-.15l1.07.63a.4.4,0,0,1,.14.56.39.39,0,0,1-.35.27Zm145.48-.14a.39.39,0,0,1-.3-.13.41.41,0,0,1,0-.59l.9-.83a.41.41,0,1,1,.57.59l-.91.85a.43.43,0,0,1-.26.18Zm-149-1.95a.43.43,0,0,1-.22-.06l-1.05-.64a.41.41,0,1,1,.42-.7l1.06.63a.42.42,0,0,1-.21.77Zm152-.94a.38.38,0,0,1-.28-.11.42.42,0,0,1,0-.58l.31-.32c.17-.2.35-.39.52-.58a.414.414,0,1,1,.62.55l-.54.59-.31.32a.39.39,0,0,1-.39.2ZM263,324.56a.33.33,0,0,1-.21-.07l-1.06-.65a.413.413,0,1,1,.44-.7l1.05.65a.42.42,0,0,1,.13.57.41.41,0,0,1-.35.2Zm158.17-1.9a.38.38,0,0,1-.25-.09.41.41,0,0,1-.07-.58c.26-.32.51-.64.76-1a.41.41,0,1,1,.65.5c-.25.33-.5.66-.76,1a.42.42,0,0,1-.32.17Zm-161.66-.29a.46.46,0,0,1-.22-.06l-1-.67a.41.41,0,1,1,.44-.69l1,.66a.41.41,0,0,1,.13.57.42.42,0,0,1-.34.19Zm-3.46-2.22a.39.39,0,0,1-.23-.07l-1-.67a.412.412,0,0,1,.45-.69l1,.67a.41.41,0,0,1,.12.57.42.42,0,0,1-.33.19Zm167.57-.81a.44.44,0,0,1-.24-.07.42.42,0,0,1-.11-.57c.23-.34.46-.68.68-1a.41.41,0,0,1,.57-.13.42.42,0,0,1,.12.57c-.22.35-.45.7-.68,1a.41.41,0,0,1-.33.2Zm-171-1.45a.46.46,0,0,1-.23-.06l-1-.69a.41.41,0,0,1,.46-.68l1,.68a.4.4,0,0,1,.11.57.39.39,0,0,1-.35.18Zm173.19-2.05a.4.4,0,0,1-.36-.61c.2-.36.4-.71.59-1.07a.41.41,0,0,1,.56-.17.42.42,0,0,1,.17.56l-.61,1.09a.39.39,0,0,1-.36.2Zm-176.62-.23a.39.39,0,0,1-.23-.07l-1-.68a.43.43,0,0,1-.12-.58.44.44,0,0,1,.58-.11l1,.69a.41.41,0,0,1-.23.75Zm-3.41-2.3a.39.39,0,0,1-.23-.07l-1-.69a.413.413,0,1,1,.47-.68l1,.69a.41.41,0,0,1-.25.75Zm181.92-1.12a.39.39,0,0,1-.18,0,.41.41,0,0,1-.19-.55l.51-1.11a.41.41,0,1,1,.75.33c-.17.38-.34.76-.52,1.13a.41.41,0,0,1-.38.2ZM242.36,311a.4.4,0,0,1-.23-.08l-1-.69a.413.413,0,1,1,.47-.68l1,.7a.4.4,0,0,1,.11.57.43.43,0,0,1-.35.18ZM239,308.67a.51.51,0,0,1-.24-.07l-1-.7a.42.42,0,0,1-.11-.58.41.41,0,0,1,.57-.1l1,.7a.41.41,0,0,1-.22.75Zm190.34-.27h-.15a.43.43,0,0,1-.24-.54c.15-.38.29-.76.43-1.14a.41.41,0,0,1,.77.27c-.14.39-.28.78-.43,1.17a.41.41,0,0,1-.41.24ZM235.6,306.33a.39.39,0,0,1-.23-.07l-1-.7a.413.413,0,0,1,.47-.68l1,.7a.41.41,0,0,1-.24.75Zm195.07-1.82h-.12a.4.4,0,0,1-.27-.51l.34-1.18a.41.41,0,1,1,.79.22c-.11.4-.23.8-.35,1.2a.41.41,0,0,1-.42.27ZM232.18,304a.4.4,0,0,1-.23-.08l-1-.7a.413.413,0,1,1,.47-.68l1,.71a.4.4,0,0,1,.1.57.43.43,0,0,1-.34.18Zm-3.39-2.34a.39.39,0,0,1-.23-.07l-1-.7a.413.413,0,0,1,.47-.68l1,.7a.414.414,0,0,1-.24.75Zm202.9-1.13h-.09a.41.41,0,0,1-.31-.49c.09-.4.17-.8.26-1.2a.408.408,0,1,1,.8.16c-.08.41-.17.81-.26,1.22a.41.41,0,0,1-.4.31Zm-206.29-1.2a.42.42,0,0,1-.24-.07l-1-.69a.42.42,0,0,1-.1-.58.41.41,0,0,1,.57-.1l1,.69a.42.42,0,0,1,.11.57.41.41,0,0,1-.34.18ZM222,297a.39.39,0,0,1-.23-.07l-1-.69a.41.41,0,0,1-.11-.57.42.42,0,0,1,.57-.12l1,.7a.41.41,0,0,1-.23.75Zm210.46-.54h-.06a.41.41,0,0,1-.34-.47c.06-.4.12-.81.17-1.21a.408.408,0,1,1,.81.1,8.65,8.65,0,0,1-.17,1.23.41.41,0,0,1-.42.37ZM218.58,294.7a.38.38,0,0,1-.22-.07l-1-.68a.42.42,0,0,1-.12-.57.43.43,0,0,1,.58-.12l1,.69a.42.42,0,0,1,.12.57.41.41,0,0,1-.37.2Zm-3.43-2.27a.47.47,0,0,1-.22-.07l-1-.68a.41.41,0,0,1-.12-.57.42.42,0,0,1,.57-.12l1,.68a.41.41,0,0,1-.23.76Zm217.79-.06h0a.41.41,0,0,1-.38-.44c0-.41.06-.82.08-1.22a.42.42,0,0,1,.83,0l-.09,1.24a.41.41,0,0,1-.45.44ZM211.69,290.2a.47.47,0,0,1-.22-.07l-1-.67a.412.412,0,1,1,.45-.69l1,.67a.41.41,0,0,1-.23.76Zm221.42-1.92h0a.41.41,0,0,1-.41-.41v-1.23a.41.41,0,1,1,.82,0c0,.24,0,.48,0,.73v.51a.41.41,0,0,1-.41.4ZM208.23,288a.34.34,0,0,1-.22-.07l-1-.65a.413.413,0,0,1,.44-.7l1,.66a.41.41,0,0,1-.22.76Zm-3.5-2.18a.39.39,0,0,1-.21-.06l-1.05-.65a.41.41,0,0,1-.14-.57.42.42,0,0,1,.57-.13l1,.64a.42.42,0,0,1,.13.57.39.39,0,0,1-.3.18ZM433,284.17a.41.41,0,0,1-.41-.39l-.09-1.22a.411.411,0,1,1,.82-.07c0,.41.07.82.09,1.24a.4.4,0,0,1-.38.43Zm-231.79-.51a.42.42,0,0,1-.21-.06l-1.06-.63a.42.42,0,0,1-.14-.57.41.41,0,0,1,.56-.14l1.07.63a.42.42,0,0,1-.22.77Zm-61.16-1.48a.38.38,0,0,1-.28-.11.42.42,0,0,1,0-.58q.42-.45.87-.9a.41.41,0,1,1,.58.58c-.29.29-.57.58-.84.88a.43.43,0,0,1-.33.13Zm57.62-.61a.42.42,0,0,1-.21-.06l-1.07-.62a.41.41,0,1,1,.41-.71l1.08.62a.42.42,0,0,1-.21.77Zm234.92-1.5a.42.42,0,0,1-.41-.36c-.05-.4-.11-.81-.18-1.21a.42.42,0,0,1,.82-.13l.18,1.23a.42.42,0,0,1-.35.47Zm-238.51-.53a.53.53,0,0,1-.2-.05l-1.08-.59a.414.414,0,1,1,.39-.73l1.09.6a.41.41,0,0,1-.2.77Zm-51.06-.2a.41.41,0,0,1-.26-.73c.31-.27.64-.53,1-.79a.42.42,0,0,1,.58.06.41.41,0,0,1-.07.58c-.32.26-.63.51-.94.78a.45.45,0,0,1-.33.1Zm47.42-1.73a.43.43,0,0,1-.19,0l-1.1-.55a.4.4,0,0,1-.18-.55.41.41,0,0,1,.55-.19l1.11.56a.41.41,0,0,1,.18.55.42.42,0,0,1-.37.18Zm-44.13-.75a.41.41,0,0,1-.23-.76c.34-.23.7-.46,1-.67a.42.42,0,0,1,.57.13.41.41,0,0,1-.14.57c-.34.21-.69.43-1,.66a.48.48,0,0,1-.2.07ZM431.88,276a.44.44,0,0,1-.41-.33q-.12-.6-.27-1.2a.41.41,0,0,1,.31-.49.4.4,0,0,1,.49.3c.1.41.19.81.28,1.22a.41.41,0,0,1-.32.49Zm-245.15-.19a.469.469,0,0,1-.17,0l-1.12-.5a.412.412,0,1,1,.32-.76l1.14.51a.39.39,0,0,1,.2.54.41.41,0,0,1-.37.23Zm-36.88-1.06a.39.39,0,0,1-.36-.23.4.4,0,0,1,.18-.55l1.12-.55a.4.4,0,0,1,.54.19.41.41,0,0,1-.19.55l-1.1.54a.41.41,0,0,1-.19.07Zm33.08-.53a.321.321,0,0,1-.14,0l-1.15-.43a.41.41,0,1,1,.28-.77l1.16.43a.41.41,0,0,1-.15.8Zm-29.32-1.15a.41.41,0,0,1-.14-.79l1.17-.43a.43.43,0,0,1,.53.26.41.41,0,0,1-.26.52c-.39.14-.77.27-1.15.42a.39.39,0,0,1-.15.04Zm25.44-.21h-.12l-1.18-.35a.411.411,0,0,1,.23-.79l1.19.35a.41.41,0,0,1,.27.52.4.4,0,0,1-.39.29ZM430.86,272a.43.43,0,0,1-.4-.3q-.16-.59-.36-1.17a.42.42,0,0,1,.27-.52.41.41,0,0,1,.51.27c.13.39.25.79.37,1.19a.41.41,0,0,1-.27.51Zm-273.32-.17a.42.42,0,0,1-.4-.31.41.41,0,0,1,.3-.5c.4-.11.81-.2,1.21-.29a.41.41,0,1,1,.18.8l-1.19.28Zm17.54-.05H175l-1.2-.25a.413.413,0,1,1,.16-.81l1.22.26a.41.41,0,0,1,.31.49.42.42,0,0,1-.41.34ZM171,271.1h0c-.4,0-.81-.1-1.21-.13a.412.412,0,1,1,.08-.82,8.879,8.879,0,0,1,1.24.14.4.4,0,0,1,.35.46.41.41,0,0,1-.46.35Zm-9.44,0a.42.42,0,0,1-.41-.36.41.41,0,0,1,.36-.46c.41-.06.82-.1,1.24-.14a.41.41,0,0,1,.45.37.43.43,0,0,1-.37.45,8.436,8.436,0,0,0-1.22.14Zm5.34-.29h-1.24a.41.41,0,1,1,0-.82h1.25a.42.42,0,0,1,0,.83Zm262.61-2.66a.4.4,0,0,1-.38-.26c-.15-.38-.3-.76-.46-1.14a.412.412,0,0,1,.76-.32c.16.39.31.77.46,1.16a.4.4,0,0,1-.23.53Zm-1.64-3.78a.4.4,0,0,1-.37-.23L427,263a.41.41,0,0,1,.17-.56.42.42,0,0,1,.56.18c.19.37.37.74.55,1.11a.4.4,0,0,1-.19.55.39.39,0,0,1-.2.07ZM426,260.72a.42.42,0,0,1-.36-.2c-.2-.36-.41-.71-.63-1.06a.42.42,0,0,1,.71-.43c.21.36.43.71.63,1.07a.42.42,0,0,1-.14.57A.54.54,0,0,1,426,260.72Zm-2.2-3.48a.43.43,0,0,1-.34-.18c-.23-.34-.46-.68-.7-1a.412.412,0,0,1,.67-.48l.71,1a.42.42,0,0,1-.11.58.479.479,0,0,1-.27.08Zm-2.42-3.33a.39.39,0,0,1-.33-.16l-.76-.95a.412.412,0,0,1,.64-.52c.26.32.52.64.77,1a.41.41,0,0,1-.07.58.49.49,0,0,1-.29.05Zm-2.64-3.16a.41.41,0,0,1-.3-.14l-.83-.91a.42.42,0,0,1,0-.59.41.41,0,0,1,.58,0c.28.31.56.61.83.92a.42.42,0,0,1,0,.59.48.48,0,0,1-.32.13Zm-2.81-3a.42.42,0,0,1-.29-.12l-.87-.87a.41.41,0,0,1,0-.58.43.43,0,0,1,.59,0l.88.88a.41.41,0,0,1,0,.58.4.4,0,0,1-.35.1Zm-3-2.85a.43.43,0,0,1-.28-.11l-.91-.82a.411.411,0,0,1,.54-.62l.92.83a.422.422,0,0,1-.27.71Zm-3.1-2.71a.39.39,0,0,1-.27-.1l-.95-.78a.412.412,0,1,1,.52-.64l1,.79a.41.41,0,0,1-.26.73Zm-3.22-2.57a.4.4,0,0,1-.25-.09l-1-.74a.414.414,0,1,1,.5-.66l1,.75a.41.41,0,0,1,.08.58.42.42,0,0,1-.33.15Zm-3.31-2.45a.37.37,0,0,1-.24-.08l-1-.7a.42.42,0,0,1,.48-.68l1,.71a.41.41,0,0,1-.24.75Zm-3.4-2.33a.38.38,0,0,1-.22-.07l-1-.68a.4.4,0,0,1-.12-.57.42.42,0,0,1,.57-.12l1,.68a.43.43,0,0,1,.12.58.44.44,0,0,1-.35.17Zm-3.46-2.22a.44.44,0,0,1-.22-.07l-.8-.49a.42.42,0,0,1-.13-.57.41.41,0,0,1,.56-.13l.81.49a.42.42,0,0,1,.13.57.41.41,0,0,1-.35.19Z"
                    fill="url(#linear-gradient-3)"
                />
                <path
                    id="Path_227"
                    d="M452.25,305.78a17.641,17.641,0,0,0,4,3,33.69,33.69,0,0,1-7.39,6.57l-.92,2.05-2.93-3.51A15.89,15.89,0,0,0,452.25,305.78Z"
                    fill="#e3e2e3"
                />
                <path
                    id="Path_228"
                    d="M436.56,372.4a.621.621,0,0,1,0-.19c.95-3.77,5.66-6.11,5.66-6.11l1.87.15a13,13,0,0,1,.76,6.25.239.239,0,0,1,0,.08A43.869,43.869,0,0,1,436.56,372.4Z"
                    fill="#707171"
                />
                <path
                    id="Path_229"
                    d="M444.85,372.58a.8.8,0,0,1-.59.6,25.651,25.651,0,0,1-7.13-.1.69.69,0,0,1-.57-.68A43.87,43.87,0,0,0,444.85,372.58Z"
                    fill="#e3e2e3"
                />
                <path
                    id="Path_230"
                    d="M444.86,363.47l-.79,3.8a.64.64,0,0,1-.53.52,5.723,5.723,0,0,1-1.23,0,.79.79,0,0,1-.62-.92l.55-3.38Z"
                    fill="#e3e2e3"
                />
                <path
                    id="Path_231"
                    d="M428.48,372.54a11.1,11.1,0,0,0,3.68-.53v.63a.41.41,0,0,1-.39.42L420.44,373a.53.53,0,0,1-.42-.76,82.85,82.85,0,0,0,8.46.3Z"
                    fill="#e3e2e3"
                />
                <path
                    id="Path_232"
                    d="M420,372.23a.556.556,0,0,1,.05-.08,14.409,14.409,0,0,1,8.58-5.39l2.41-.07a11.48,11.48,0,0,1,1.1,5.32,11.1,11.1,0,0,1-3.68.53A82.843,82.843,0,0,1,420,372.23Z"
                    fill="#707171"
                />
                <path
                    id="Path_233"
                    d="M431.51,363c0,.18-.36,2.91-.49,4a.53.53,0,0,1-.44.48,5.5,5.5,0,0,1-1.66,0,.71.71,0,0,1-.54-.72v-4.29Z"
                    fill="#e3e2e3"
                />
                <path
                    id="Path_234"
                    d="M433.44,313.12a214.9,214.9,0,0,0-5.71,50,1.07,1.07,0,0,0,.85,1.05,11.921,11.921,0,0,0,2.7.31,1,1,0,0,0,1-.83c.82-4.79,5.51-31.76,8.18-36.14,0,0,1.75,24,1.19,36.49a.59.59,0,0,0,.52.61,10.359,10.359,0,0,0,2.17,0,.78.78,0,0,0,.7-.67c.58-4,3.93-28.17,3.79-45.54,0-1-2.59-5.24-2.59-5.24Z"
                    fill="#474747"
                />
                <path
                    id="Path_235"
                    d="M425.35,286.34a24.048,24.048,0,0,0,2.46-3.76c1-1.83.08,1.18.34-.88,7.25-5.23,18.15-2.58,22.37-2.05a5.64,5.64,0,0,1,3.56,1.91c3.61,4.18,11.55,15.64,2.21,27.18a17.641,17.641,0,0,1-4-3c1-2.91,1.11-6.63-1.05-11.2-.08.37-.17.72-.28,1.08a66.261,66.261,0,0,0-3.13,19.13.62.62,0,0,1-.38.56c-3.93,1.57-11.49.63-14,.25a.85.85,0,0,1-.72-1c1.25-9-5.14-23.87-6.83-27.58a2.549,2.549,0,0,0-.55-.64Z"
                    fill="#707171"
                />
                <path
                    id="Path_236"
                    d="M443.73,272.05l.76,7.73s-4.35,1.31-7.51-.92l2.22-7Z"
                    fill="#e3e2e3"
                />
                <path
                    id="Path_237"
                    d="M438.69,263.24c-.11.1-4.42,8.57-4.42,8.57l4.89,2.36,5.28-7.42S440.44,261.59,438.69,263.24Z"
                    fill="#e3e2e3"
                />
                <path
                    id="Path_238"
                    d="M442.28,267a.83.83,0,0,1-.06.69l-2.44,4.06a.579.579,0,0,1-.14.17,1.28,1.28,0,0,1-2.05,0,6.83,6.83,0,0,0-1.92-2.09.77.77,0,0,0-1.05.35,28.388,28.388,0,0,0-1.67,4,.76.76,0,0,0,.45.95,21.6,21.6,0,0,0,4.68,1.37.77.77,0,0,0,.74-.32c.75-1,2.85-3.88,3.57-4.6a2.66,2.66,0,0,1,2.45-.25.82.82,0,0,0,.63-.08,1.72,1.72,0,0,0,.64-2.62.78.78,0,0,1,.25-1.06A1.72,1.72,0,0,0,447,265a2.43,2.43,0,0,0-2.64-1.29.83.83,0,0,1-.85-.48.51.51,0,0,0-.4-.31.76.76,0,0,1-.61-.89,2,2,0,0,0-1.12-2.29c-2.11-1.16-3.95.73-4.42,2.32s1.88,2.73,3.37,2.92C441.44,265.14,442,266.33,442.28,267Z"
                    fill="#707171"
                />
                <path
                    id="Path_239"
                    d="M441.47,273s.94-2.75,2.14-2.65,2.15,1.3.66,2.64C442.42,274.65,441.47,273,441.47,273Z"
                    fill="#e3e2e3"
                />
                <path
                    id="Path_240"
                    d="M451.59,293.88a24.52,24.52,0,0,0,1-9.62l-.44.05a23.86,23.86,0,0,1-1,9.42Z"
                    fill="#474747"
                />
                <path
                    id="Path_241"
                    d="M440.62,326.92a.21.21,0,0,0,.21-.17c.48-1.86,4.1-3.9,4.14-3.93a.21.21,0,0,0,.08-.29.22.22,0,0,0-.3-.09c-.15.09-3.81,2.16-4.34,4.2a.22.22,0,0,0,.15.27Z"
                    opacity="0.5"
                />
                <path
                    id="Path_242"
                    d="M410.65,288.77c8.19,1.23,13.53-3.94,17.5-7.07,5.26-4.14,9.34-2.13,9.34-2.13l-5.6,10.69c-8.36,7.89-16.94,6.14-22.35,3.58a10.4,10.4,0,0,1,1.11-5.07Z"
                    fill="#707171"
                />
                <path
                    id="Path_243"
                    d="M399.13,283.89l2.72,1.46a23.73,23.73,0,0,0,8.8,3.42,10.4,10.4,0,0,0-1.11,5.07,24.62,24.62,0,0,1-5.59-3.58C397.79,286.59,399.13,283.89,399.13,283.89Z"
                    fill="#e3e2e3"
                />
                <path
                    id="Path_244"
                    d="M391.13,287.71a2,2,0,0,1,1.17-1.28l5.52-2.21s.08-.71-1.17-1.19a1.65,1.65,0,0,1-.95-1.88s1.7.78,4.2,2a5.91,5.91,0,0,1,2.65,2.89l-1.42,1.87a25.32,25.32,0,0,1-10.3.81Z"
                    fill="#e3e2e3"
                />
                <circle
                    id="Ellipse_27"
                    cx="6.66"
                    cy="6.66"
                    r="6.66"
                    transform="translate(476.62 239.92)"
                    fill="#fff"
                    stroke="#e2e2e2"
                    strokeMiterlimit="10"
                    strokeWidth="2"
                />
                <circle
                    id="Ellipse_28"
                    cx="9.82"
                    cy="9.82"
                    r="9.82"
                    transform="translate(464.05 201.76)"
                    fill="#fff"
                    stroke="#e2e2e2"
                    strokeMiterlimit="10"
                    strokeWidth="2"
                />
                <circle
                    id="Ellipse_29"
                    cx="6.66"
                    cy="6.66"
                    r="6.66"
                    transform="translate(277.36 399.86)"
                    fill="#fff"
                    stroke="#e2e2e2"
                    strokeMiterlimit="10"
                    strokeWidth="2"
                />
                <circle
                    id="Ellipse_30"
                    cx="9.82"
                    cy="9.82"
                    r="9.82"
                    transform="translate(238.97 382.84)"
                    fill="#fff"
                    stroke="#e2e2e2"
                    strokeMiterlimit="10"
                    strokeWidth="2"
                />
                <path
                    id="Path_245"
                    d="M310.63,81.58H303V73.92a1,1,0,0,0-.95-1h0a1,1,0,0,0-1,1v7.66H293.4a1,1,0,0,0,0,2H301v7.67a.975.975,0,0,0,1.95,0h0V83.51h7.67a.965.965,0,1,0,.01-1.93Z"
                    fill="#e2e2e2"
                    stroke="#e2e2e2"
                    strokeMiterlimit="10"
                    strokeWidth="0.75"
                />
                <path
                    id="Path_246"
                    d="M414.92,385.06H409.4v-5.52a.68.68,0,0,0-.69-.68h0a.69.69,0,0,0-.7.68v5.52H402.5a.7.7,0,1,0,0,1.39H408V392a.7.7,0,0,0,1.39,0h0v-5.52h5.52a.7.7,0,1,0,0-1.39Z"
                    fill="#e2e2e2"
                    stroke="#e2e2e2"
                    strokeMiterlimit="10"
                    strokeWidth="0.75"
                />
                <path
                    id="Path_247"
                    d="M379,398.23h-7.35v-7.34a.91.91,0,0,0-.91-.91h0a.93.93,0,0,0-.94.91v7.34h-7.33a.93.93,0,0,0,0,1.85h7.33v7.35a.93.93,0,0,0,.94.91.91.91,0,0,0,.91-.91h0v-7.35H379a.92.92,0,0,0,.92-.92A.93.93,0,0,0,379,398.23Z"
                    fill="#e2e2e2"
                    stroke="#e2e2e2"
                    strokeMiterlimit="10"
                    strokeWidth="0.75"
                />
                <ellipse
                    id="_Path_"
                    cx="117.22"
                    cy="11.51"
                    rx="117.22"
                    ry="11.51"
                    transform="translate(203.06 439.17)"
                    fill="#f4f5f6"
                />
            </g>
        </SVGIcon>
    );
}
